export default "__VITE_ASSET__1adfbb2a__"